export const chart = (
    height: number,
    titles: { name: string; opposite: boolean }[],
    dateKeys: { date: string; styled: string }[],
    series: any[],
    clamp?: { min?: number; max?: number },
    overridable?: Record<any, any>
) => {
    return {
        chart: {
            height,
            zoomType: 'xy',
            animation: false,
        },
        title: '',
        plotOptions: {
            series: {
                animation: {
                    duration: 0,
                },
            },
        },
        credits: { enabled: false },
        xAxis: {
            categories: dateKeys.map(({ styled }) => styled),
        },
        yAxis: titles.map((title) => ({ title: { text: title.name }, opposite: title.opposite, ...clamp })),
        series,
        ...overridable,
    };
};
